module.exports = __webpack_public_path__ + "static/social_network_poster-d785cc08c4d97aa7defce0f039f383ed.png";